import { __extends } from "tslib";
import AxiosMockAdapter from 'axios-mock-adapter';
import { ClientSearchBuilder } from './sdk.builder';
var ClientSearchMock = /** @class */ (function (_super) {
    __extends(ClientSearchMock, _super);
    function ClientSearchMock(client) {
        var _this = _super.call(this) || this;
        var axiosInstance = client.getInstance();
        _this.mock = new AxiosMockAdapter(axiosInstance);
        return _this;
    }
    ClientSearchMock.prototype.getHistory = function () {
        return this.mock.history;
    };
    ClientSearchMock.prototype.restore = function () {
        this.mock.restore();
        return this;
    };
    ClientSearchMock.prototype.mockSearchRequest = function () {
        var _this = this;
        var searchMock = this.mock.onPost('/v1/search');
        return {
            reply: function (code) {
                if (code === void 0) { code = 200; }
                return searchMock.reply(code, _this.getSearchResponse());
            },
            replyOnce: function (code) {
                if (code === void 0) { code = 200; }
                return searchMock.replyOnce(code, _this.getSearchResponse());
            },
        };
    };
    ClientSearchMock.prototype.mockGetTotalsRequest = function () {
        // TODO: implement when API ready.
        throw new Error('Not implemented');
    };
    ClientSearchMock.prototype.mockGetDocumentTypesRequest = function () {
        var _this = this;
        var documentTypesMock = this.mock.onGet('/v1/search/sources');
        return {
            reply: function (code) {
                if (code === void 0) { code = 200; }
                return documentTypesMock.reply(code, _this.getDocumentTypesResponse());
            },
            replyOnce: function (code) {
                if (code === void 0) { code = 200; }
                return documentTypesMock.replyOnce(code, _this.getDocumentTypesResponse());
            },
        };
    };
    return ClientSearchMock;
}(ClientSearchBuilder));
export { ClientSearchMock };
//# sourceMappingURL=sdk.mock.js.map